import React from "react";
import GdanskSaleContentContainer from "../GdanskSaleContentContainer";
import EAMultipleChoiceChipSelector from "../../shared/ChoiceChip/EAMultipleChoiceChipSelector";
import EADivider from "../../shared/EADivider";
import { GdanskSaleForm } from "../../../models/GdanskSaleForm";
import ProductTypeInfo from "../Other/ProductTypeInfo";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import {
  GDANSK_KIND_BASIC_PASS,
  GDANSK_KIND_BEARER_PASS,
  GDANSK_KIND_PASS_OPEN,
  GDANSK_KIND_SINGLE_TICKET,
  GDANSK_KIND_SWIMMING_TRACK,
  GDANSK_PASS,
  GDANSK_TICKET,
} from "./gdanskSaleStepsConsts";
import { ExerciseInt } from "../../../models/ExerciseInt";

interface IProps {
  form: GdanskSaleForm;
  setForm: (form: GdanskSaleForm) => void;
  onNextStep: () => void;
}

const GdanskSaleStep1: React.FC<IProps> = ({ form, setForm, onNextStep }) => {
  const reservationConfig = useSelector((state: State) => state.config.configuration.reservationConfig);

  const defaultFormValues = {
    date: new Date(),
    bookingGroupIds: "",
    colorIds: "",
    materialGroupIds: "",
    intructorRule: false,
    exercise: {} as ExerciseInt,
  };

  const handleChangeProductTypeValue = (value: string) => {
    setForm({ ...defaultFormValues, productMainType: value, kind: "" });
  };

  const handleChangeSecondaryProductType = (value: string) => {
    setForm({ ...defaultFormValues, productMainType: form.productMainType, kind: value });
  };

  const getOptions = () => {
    const options = [];
    if (reservationConfig.ticketActive) {
      options.push({ value: GDANSK_TICKET, label: "Bilet" });
    }
    if (reservationConfig.passActive) {
      options.push({ value: GDANSK_PASS, label: "Karnet" });
    }
    return options;
  };

  const getOptionsByProductType = () => {
    const options = [];

    if (form.productMainType === GDANSK_TICKET) {
      if (reservationConfig.singleTicketActive) {
        options.push({ value: GDANSK_KIND_SINGLE_TICKET, label: "Jednorazowy" });
      }
      if (reservationConfig.swimmingTracksActive) {
        options.push({ value: GDANSK_KIND_SWIMMING_TRACK, label: "Intruktorski" });
      }
    } else {
      if (reservationConfig.basicPassActive) {
        options.push({ value: GDANSK_KIND_BASIC_PASS, label: "Karnet tradycjny" });
      }
      if (reservationConfig.passOpenActive) {
        options.push({ value: GDANSK_KIND_PASS_OPEN, label: "Karnet OPEN" });
      }
      if (reservationConfig.bearerPassActive) {
        options.push({
          value: GDANSK_KIND_BEARER_PASS,
          label: "Karnet na okaziciela",
        });
      }
    }

    return options;
  };

  return (
    <GdanskSaleContentContainer
      title="Co chciałbyś kupić?"
      description="Drogi kliencie masz do wyboru zakup karnetu lub biletu."
      showButtons={Boolean(form.kind)}
      showGoBackButton={false}
      onClickGoBack={() => {}}
      onClickNext={onNextStep}
    >
      <EAMultipleChoiceChipSelector
        options={getOptions()}
        selectedValue={form.productMainType}
        onSelect={(value) => handleChangeProductTypeValue(value)}
        width="70%"
      />
      {form.productMainType && (
        <>
          <EADivider />
          <EAMultipleChoiceChipSelector
            options={getOptionsByProductType()}
            selectedValue={form.kind}
            onSelect={(value) => handleChangeSecondaryProductType(value)}
            width="70%"
          />
        </>
      )}
      {form.kind && <ProductTypeInfo value={form.kind} reservationConfig={reservationConfig} />}
    </GdanskSaleContentContainer>
  );
};

export default GdanskSaleStep1;
